import { newId } from "../utils/dataTypesUtils"
import { Tax, TaxType, TaxBase, VatTaxCode } from "../../../modules/administration"

// Built on demand to avoid reading the enum while the administration module is still initializing
export const supportedVatTaxCodes = (): VatTaxCode[] => [
    VatTaxCode.VAT_21,
    VatTaxCode.VAT_10_5
]

export const isSupportedVatTaxCode = (code?: string): code is VatTaxCode =>
    supportedVatTaxCodes().includes(code as VatTaxCode)

export const vatTaxCodeFromYield = (vatTaxYield?: number): VatTaxCode | undefined => {
    if (vatTaxYield === 21) return VatTaxCode.VAT_21
    if (vatTaxYield === 10.5) return VatTaxCode.VAT_10_5
    return undefined
}

export const taxes = (companyId: string): Tax[] => [
    {
        companyId,
        id: newId(),
        code: VatTaxCode.VAT_21,
        legalCode: VatTaxCode.VAT_21,
        type: TaxType.VAT,
        taxBase: TaxBase.PRICE_WITHOUT_VAT,
        name: 'IVA 21%',
        nonTaxableMin: 0,
        yield: 21
    },
    {
        companyId,
        id: newId(),
        code: VatTaxCode.VAT_10_5,
        legalCode: VatTaxCode.VAT_10_5,
        type: TaxType.VAT,
        taxBase: TaxBase.PRICE_WITHOUT_VAT,
        name: 'IVA 10,5%',
        nonTaxableMin: 0,
        yield: 10.5
    }
]
